import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ElvisDSModule } from 'ngx-elvis-ds';

import { ListDialogPage } from './list-dialog.page';
import { GUIBaseModule } from '../../gui-base/gui-base.module';
// import { MomentModule } from 'ngx-moment';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        GUIBaseModule,
        // MomentModule,
        ElvisDSModule,
    ],
    declarations: [
        ListDialogPage,
    ]
})
export class ListDialogPageModule {}
